import ContentCallout from './component.jsx'

export default ContentCallout
